import axios from 'axios';

let API_BASE_URL;
let logoutCallback = null; // Store the logout callback

if (window.location.hostname === 'localhost') {
  // Local dev (React dev server + backend on port 8000)
  API_BASE_URL = `http://localhost:8000/api`;
} else {
  // Production (frontend + backend behind same domain)
  API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 180000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.warn("Token expired or invalid. Clearing token and redirecting to login.");
      localStorage.removeItem("token");

      // Call the logout callback to update React state
      if (logoutCallback) {
        logoutCallback();
      }
    }
    return Promise.reject(error);
  }
);

export const musicAPI = {
  // Set the logout callback
  setLogoutCallback: (callback) => {
    logoutCallback = callback;
  },

  login: async (username, password) => {
    const formData = new URLSearchParams();
    formData.append("username", username);
    formData.append("password", password);

    const response = await api.post("/login", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    localStorage.setItem("token", response.data.access_token);
    return response.data;
  },

  logout: async () => {
    localStorage.removeItem("token");
  },

  // Get current streaming status
  getStatus: async () => {
    const response = await api.get('/status');
    return response.data;
  },

  // Get all songs
  getAllSongs: async () => {
    const response = await api.get('/songs');
    return response.data;
  },

  // Get statistics
  getStats: async () => {
    const response = await api.get('/stats');
    return response.data;
  },

  save_youtube_link: async (data) => {
    try {
      const response = await api.post('/youtube/add', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error:', error);
      throw error;

    }
  },

  uploadFile: async (files) => {
    try {
      const formData = new FormData();
      if (Array.isArray(files)) {
        files.forEach((file, index) => {
          formData.append('files', file);
        });
      } else {
        formData.append('files', files);
      }
      
      
      const response = await api.post('/v2/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      if (!response.data) {
        throw new Error('No data received from server');
      }
      
      return response.data;
      
    } catch (error) {
      console.error('API Error:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  },
  
  deleteSong: async (songId) => {
    const response = await api.delete(`/songs/${songId}`);
    return response.data;
  },

  healthCheck: async () => {
    const response = await api.get('/health');
    return response.data;
  },

  fetch_youtube_playlist: async (url) => {
    try {
      const response = await api.get(`/youtube/playlist?url=${url}`);
      return response.data.videos;
    } catch (error) {
      console.error('Error:', error);
      throw error;

    }
  },

};

export default musicAPI;